export enum StatusFilter {
  ONLINE = 'ONLINE',
  OFFLINE = 'OFFLINE',
  BOTH = 'BOTH',
}

export enum SourceFilter {
  EMBARQUE = '4G',
  DEBARQUE = 'ALGO',
  BLE = 'BLE',
  LORA = 'LORA',
  ALL = 'ALL',
}

export interface TrackerPositionFilters {
  from?: Date | null;
  to?: Date | null;
  statusFilter?: StatusFilter;
  sourceFilter?: SourceFilter[];
}
